import Metadata from '../components/Metadata';
import ContactForm from '../components/ContactForm';

export default function Kontakt() {
  return (
    <>
      <Metadata
        title="Kontakt - K. Pheiffer Construction"
        description="Kontakt K. Pheiffer Construction for en dialog om dit næste bygge- eller renoveringsprojekt."
      />

      {/* Page Header */}
      <section className="relative text-white py-24 sm:py-32 overflow-hidden bg-slate-950">
        {/* Background Image with Overlay */}
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-500 scale-105"
          style={{ backgroundImage: `url('https://assets.auxodev.dk/assets/cf131c5c-877c-4f32-8100-a69e4d795732/danish-house-renovation.jpg')` }}
        />
        <div className="absolute inset-0 bg-black/75 backdrop-blur-[1px]" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-black/40" />

        <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-xs font-bold uppercase tracking-widest text-emerald-400">
            Kontakt os
          </span>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight mt-2">
            Lad os høre fra dig
          </h1>
          <p className="mt-4 text-slate-300 text-base sm:text-lg max-w-2xl mx-auto">
            Går du med bygge- eller renoveringsplaner? Kontakt os i dag for en uforpligtende snak og et godt tilbud.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 sm:py-24 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            {/* Contact Info & Map */}
            <div className="lg:col-span-5 space-y-8">
              <div className="space-y-6">
                <h2 className="text-2xl font-bold text-slate-900">
                  Virksomhedsoplysninger
                </h2>
                <p className="text-slate-500 text-sm sm:text-base leading-relaxed">
                  Du er altid velkommen til at ringe eller skrive til os. Vi bestræber os på at svare på alle e-mails inden for 24 timer.
                </p>

                <div className="space-y-4 pt-4 border-t border-slate-100">
                  {/* Company Name & Address */}
                  <div className="flex items-start gap-4">
                    <div className="h-10 w-10 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center flex-shrink-0 border border-emerald-100">
                      <i className="fa-regular fa-building text-base" />
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 text-sm uppercase tracking-wider">
                        K. Pheiffer Construction
                      </h4>
                      <p className="text-slate-600 text-sm mt-1">
                        Snaremosevej 23H<br />
                        7000 Fredericia
                      </p>
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="flex items-start gap-4">
                    <div className="h-10 w-10 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center flex-shrink-0 border border-emerald-100">
                      <i className="fa-regular fa-phone text-base" />
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 text-sm uppercase tracking-wider">
                        Telefon
                      </h4>
                      <a
                        href="tel:+4560183562"
                        className="text-slate-600 hover:text-emerald-600 text-sm mt-1 block font-semibold transition-colors whitespace-nowrap"
                      >
                        60 18 35 62
                      </a>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="flex items-start gap-4">
                    <div className="h-10 w-10 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center flex-shrink-0 border border-emerald-100">
                      <i className="fa-regular fa-envelope text-base" />
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 text-sm uppercase tracking-wider">
                        E-mail
                      </h4>
                      <a
                        href="mailto:kontakt@kpheiffer.dk"
                        className="text-slate-600 hover:text-emerald-600 text-sm mt-1 block font-semibold transition-colors whitespace-nowrap"
                      >
                        kontakt@kpheiffer.dk
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* Map */}
              <div className="space-y-3">
                <h3 className="text-lg font-bold text-slate-900">Vores placering</h3>
                <div className="relative rounded-xl overflow-hidden border border-slate-200 hover:border-emerald-600 aspect-[4/3] bg-slate-100 shadow-sm transition-all duration-500 hover:shadow-md hover:shadow-emerald-600/10 group">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2249.497121287957!2d9.704257177306282!3d55.54984260655162!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x464c97434f0d36ef%3A0x86701b9794350f58!2sSnaremosevej%2023H%2C%207000%20Fredericia!5e0!3m2!1sda!2sdk!4v1719140000000!5m2!1sda!2sdk"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="K. Pheiffer Construction - Snaremosevej 23H, Fredericia"
                    className="absolute inset-0 w-full h-full grayscale opacity-85 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500"
                  ></iframe>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-7">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
